/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable object-curly-newline */
/* eslint-disable max-len */
/* global window */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { get } from 'lodash';
import ModuleContainer from 'components/ModuleContainer/ModuleContainer';
import { Col, Row } from 'reactstrap';
import withTranslate from 'react-redux-multilingual/lib/withTranslate';
import Loader from 'components/Loader/Loader';
import Icon from 'components/Icon/Icon';
import './AnalystReports.scss';
import { requestResearchHistory, researchIdMap, getResearchBySingleFieldValue } from 'Actions/ResearchActions';
import PdfLink from 'Views/Shared/LinkPdf/LinkPdf';

const AnalystReports = props => {
	const { format } = window;
	const { translate } = props;
	const dispatch = useDispatch();
	const [reports, setReports] = useState([]);

	const getData = (field, value) => new Promise((resolve, reject) => {
		dispatch(requestResearchHistory(
			researchIdMap.cibcResearchHistory,
			getResearchBySingleFieldValue(field, value),
			false,
			response => {
				format.removeUtcTimezoneFromProperty(response, 'data.items.0.DocumentDate');
				resolve(get(response, 'data.items.0'));
			}
		));
	});

	const assignTitleAndDescription = reportType => {
		let title = '';
		let description = '';
		switch (reportType) {
			case 'The Week Ahead':
				title = translate('theWeekAheadAnalystReports');
				description = translate('theWeekAheadDescription');
				break;
			case 'Monthly FX Outlook':
				title = translate('monthlyFxOutlook');
				description = translate('monthlyFxOutlookDescription');
				break;
			case 'Economic Insights':
				title = translate('economicInsights');
				description = translate('economicInsightsDescription');
				break;
			case 'Industry Update':
				title = translate('canadianResearchReview');
				description = translate('canadianResearchReviewDescription');
				break;
			default:
				title = '-';
				description = '-';
		}
		return { title, description };
	};

	useEffect(() => {
		Promise.all([
			getData('ReportType', 'Monthly FX Outlook'),
			getData('ReportType', 'The Week Ahead'),
			getData('ReportType', 'Economic Insights'),
			getData('Headline', 'Canadian Research Universe And Common Stock Universe')
		]).then(values => {
			values.sort((a, b) => (new Date(b.DocumentDate)) - (new Date(a.DocumentDate)));
			setReports(values);
		});
	}, []);

	const constructRow = rowData => {
		if (rowData) {
			const { title, description } = assignTitleAndDescription(rowData.ReportType);
			return ([
				<Col xs className="reports-column" key={rowData.documentId}>
					<div className="mb-1 font-weight-bold">
						{title}
					</div>

					<p className="desc">{description}</p>
					<Row className="mb-0">
						{(!rowData || format.moment().diff(format.moment(get(rowData, 'DocumentDate')), 'days') > 365)
							? (
								<div>
									<strong>{translate('reportNotAvailable')}</strong>
								</div>
							)
							: (
								<Row>
									<span className="report-date">
										{format.monthDayYearTime(rowData.DocumentDate)}
										&nbsp;&nbsp;|&nbsp;&nbsp;
									</span>
									<PdfLink
										className="pdf-link"
										researchId={researchIdMap.cibcResearchHistory}
										documentId={rowData.documentId}
										headline={translate('openPdf')}
										docDate={rowData.DocumentDate}
										feedId={rowData.FeedID}
										inlineFileSize
										sourceOnSecondLine={false}
										hideFileSize
										anchorClassName="text"
										wcUSsuage />
								</Row>

							)}
					</Row>
				</Col>
			]);
		}
		return null;
	};

	const reportsTopRow = [constructRow(reports[0]), <Col xs="auto pipeline d-none d-xxs-pipe1" key="d1" />, constructRow(reports[1])].filter(row => row !== null);
	const reportsBottomRow = [constructRow(reports[2]), <Col xs="auto pipeline d-none d-xxs-pipe2" key="d2" />, constructRow(reports[3])].filter(row => row !== null);

	return (
		<ModuleContainer hideHeaderBorder className="reports-module">

			{reportsTopRow.length === 0 ? <Loader /> : null}
			{reportsTopRow.length > 0 ? (
				<Row noGutters className="reports-row" style={{ marginTop: 0 }}>
					{reportsTopRow}
				</Row>
			) : null}
			{reportsBottomRow.length > 0 ? (
				<Row noGutters className="reports-row">
					{reportsBottomRow}
				</Row>
			) : null}

		</ModuleContainer>
	);
};

export default withTranslate(AnalystReports);
